
import { WDFormInput } from './wd-form-input';
import WDDropdown from '../dropdown/wd-dropdown';
import WDUtil from '../../core/wd-util';

export class WDFormTextselect extends WDFormInput
{
  #dropdown = null;
  #isFetching = false;
  #lastKeyedUp = null;

  constructor(opts)
  {
    const settings = {
      templates: {
        label: '${label}',
        value: '${value}',
      }
    };

    WDUtil.merge(settings, opts);

    //don't let the parent set the value just yet
    const useValue = settings?.value !== undefined ? settings.value : null;
    delete (settings.value);

    super(settings);
    
    this.on('options:fetch',() => this.#isFetching = true);
    this.on('options:fetched',() => this.isFetching = false);

    this.input.addEventListener('keyup',(evt) => this.handleKeyUp(evt));
    this.input.addEventListener('keydown', (evt) => this.handleKeyDown(evt));

    //may need something better later
    if (this.constructor === WDFormTextselect) {

      if (useValue !== null) this.value = useValue;

      this.input.addEventListener('change',() => {
        this.trigger('change');
      });
    }
  
  };

  connectedCallback()
  {
    super.connectedCallback();
    const dd = this.dropdown;
  };

  set readonly(val)
  {
    super.readonly = val;

    if (val == true)
    {
      this.input.classList.remove('dropdown-toggle');
      delete this.input.dataset.bsToggle;
    }
    else
    {
      this.input.classList.add('dropdown-toggle');
      this.input.dataset.bsToggle = 'dropdown';
    }
  };

  get dropdown()
  {
    if (!this.#dropdown)
    {
      this.#dropdown = new WDDropdown(this.config);
      this.#dropdown.on('options:set', (evt) => this.handleOptionsSet(evt));

      this.inputGroup.append(this.#dropdown);
      this.input.classList.add('dropdown-toggle');
      this.input.dataset.bsToggle = 'dropdown';

      this.#dropdown.on('item:selected', (evt) => this.value = evt.detail.model );
      this.#dropdown.on('keyup', evt => this.handleDropdownKeyUp(evt) );
    }

    return this.#dropdown;
  }

  selectFirst()
  {
    if (this.options.length > 0)
    {
      this.value = this.options[0];
      this.dropdown.hide();
    }
    
  }

  selectFirstOption()
  {
    if (this.#isFetching == true)
    {
      this.once('options:fetched', () => this.selectFirst() );
    }
    else
    {
      this.selectFirst();
    }
  };

  //placeholder for subclasses with more advanced value handling
  //that want to reset the value without triggering anything
  resetValue()
  {
  }

  /**
   * 
   * bootstrap dropdown workaround.  Bootstrap captures arrowdown and up keydown events
   * so we use keyup to figure out when the user has hit the up arrow while focused on
   * the first list item to get back to the text box for more searching 
   */
  handleDropdownKeyUp(evt)
  {
    if (evt.key == 'ArrowUp')
    {
      if (this.#lastKeyedUp == this.dropdown.firstItem)
      {
        this.input.focus();
        evt.preventDefault();
      }
    }

    this.#lastKeyedUp = document.activeElement;
  }

  handleKeyDown(evt)
  {
    if (this.readonly) return;

    if (this.options.length > 0)
    {
      if (evt.key == 'ArrowDown')
      {
        //stop the dropdown from scrolling down
        this.dropdownShow();

        //advance down to the first item in the dropdown
        if (document.activeElement == this.input)
        {
          this.dropdown.firstItem.focus();
          evt.preventDefault();
        }
      }
      else if (evt.key == 'Enter')
      {
        evt.preventDefault();
        this.selectFirstOption();
      }
    }
   
  };

  // Override parent's handleKeyUp to use this.value instead of this.data
  handleKeyUp(evt)
  {
    if (this.readonly) return;

    // Check if the key is alphanumeric (letters, numbers, space, or common punctuation for search)
    const isAlphanumeric = /^[a-zA-Z0-9\s\-_\.@#]$/.test(evt.key);

    if (isAlphanumeric)
    {
      //this.resetValue();
      this.dropdown.filter(this.input.value);
      this.dropdownShow();  
    }
    // If Backspace is pressed and input is empty, set value to null
    else if (evt.key === 'Backspace' && this.input.value.trim() === '')
    {
      this.value = null;
      this.dropdown.filter('');
      this.dropdownShow();
    }
  }

  dropdownShow()
  {
    if (!this.#dropdown.classList.contains('show'))
    {
      this.#dropdown.show();
    }
  };

  handleOptionsSet(evt)
  {
    if (this.options.length > 0)
    {
      this.input.classList.add('dropdown-toggle');
      this.input.dataset.bsToggle = 'dropdown';
    }
    else
    {
      this.input.classList.remove('dropdown-toggle');
      delete (this.input.dataset.bsToggle);
    }

  };

  get options() { return this.dropdown.options; };
  set options(newOptions) { return this.dropdown.options = newOptions; };
  get fetch() { return this.dropdown.fetch; };
  set fetch(f) { this.dropdown.fetch = f; };
  set fetchURI(uri) { return this.dropdown.fetchURI = uri; };
  get fetchOptions() { return this.dropdown.fetchOptions; };

  get value() { return this.input.value; };
  set value(val)
  { 
    if (val === null)
    {
      this.input.value = '';
    }
    //if the dropdown is clicked, we end up here
    else if (typeof (val) == 'object')
    {
      this.input.value = this.config.templates.value.interpolate(val);
    }
    else
    {
      this.input.value = val;
    }
  }
};

customElements.define('wd-form-textselect', WDFormTextselect);
